module.exports = __webpack_public_path__ + "public/img/15.4b0db780.png";